export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11341.e9d67d5d.jpg";